import { useMemo } from 'react';
import { usePermissions, PERMISSIONS_OPERATORS } from 'modules/taboola-common-frontend-modules/authentication';

export const useChatAgentRecommendationsPermission = ({ recommendations = [], permissionPrefix = 'CHAT_AGENT_' }) => {
    const permissionNames = useMemo(() => {
        const permissionNamesSet = new Set();
        for (const recommendation of recommendations) {
            if (recommendation?.type) {
                permissionNamesSet.add(`${permissionPrefix}${recommendation.type}`);
            }
        }
        return Array.from(permissionNamesSet);
    }, [recommendations, permissionPrefix]);

    const isPermitted = usePermissions(permissionNames, PERMISSIONS_OPERATORS.OR);
    return permissionNames.length > 0 && isPermitted;
};
